import axios from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function NetErrorPage() {
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/v1/health`, {
        withCredentials: true,
        headers: { 'Nuri-Web': 'Nuri-Web' },
      })
      .then((resp) => navigate('/home/status-board', { replace: true }))
      .catch((err) => console.log('accrue Error'));
  }, []);

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <h1 style={{ fontSize: '36px', color: '#ff8b08' }}>
        {'오류가 발생했습니다. 잠시 후 다시 시도 해주세요.'}
      </h1>
    </div>
  );
}
